export enum HELPFUL_TIPS_LINKS {
  techSpec = 'https://help.dcm.disneyadvertising.com/hamhub/s/article/Technical-specifications',
  terms = 'https://www.disneycampaignmanager.com/disney-campaign-manager-terms/#ads-and-campaigns',
  learnMore = 'https://help.dcm.disneyadvertising.com/hamhub/s/article/Quick-Fixes-for-Common-Ad-Rejections',
}
